import { useEffect } from "react";
import { useAppDispatch } from "../app/hooks";
import { syncFromStorage } from "../features/auth/authSlice";

const AUTH_STORAGE_KEYS = ["maleva_auth_token", "maleva_auth_user", "token", "user"];

export const useStorageSync = () => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    const handleStorageChange = (event: StorageEvent) => {
      if (event.key && AUTH_STORAGE_KEYS.includes(event.key)) {
        dispatch(syncFromStorage());
      }
    };

    window.addEventListener("storage", handleStorageChange);

    return () => {
      window.removeEventListener("storage", handleStorageChange);
    };
  }, [dispatch]);
};
